import './index.css';
import { jsx } from 'react/jsx-runtime';
import { Cell, CellText } from '@hh.ru/magritte-ui-cell';

const TreeSelectorItemBase = ({ disabled, input, item, isXS, labelRight, }) => {
    const cellProps = {
        [isXS ? 'right' : 'left']: input,
        ...(isXS && labelRight && { right: labelRight }),
    };
    return (jsx(Cell, { disabled: disabled, ...cellProps, Element: isXS || !input ? 'div' : 'label', align: "top", children: jsx(CellText, { "data-qa": `tree-selector-item-text tree-selector-item-text-${item.id}`, children: item.text }) }));
};

export { TreeSelectorItemBase };
//# sourceMappingURL=TreeSelectorItemBase.js.map
